module.exports = __webpack_public_path__ + "img/DESC_SORT.e9b18bde.svg";